import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { loadClientInfo } from 'loopback-react-request';

export interface  ClientInfoDispatcherProps {
  clientInfo: GlobalPrivateState['clientInfo'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: any;
}

export class ClientInfo extends React.Component< ClientInfoDispatcherProps, any> {

  componentDidMount() {
    this.props.dispatch(loadClientInfo());
  }

  componentDidUpdate(prevProps: ClientInfoDispatcherProps) {
    const clientInfo = prevProps.clientInfo && prevProps.clientInfo.result;
    const newTimeStamp = Math.floor(Date.now() / 1000);
    const oldTimeStamp = clientInfo && clientInfo.timestamp ? clientInfo && clientInfo.timestamp + (100 * 60) : undefined;  
    if (oldTimeStamp && (newTimeStamp !== oldTimeStamp) && (oldTimeStamp < newTimeStamp)) {
      // this.props.dispatch(loadClientInfo());
    }
  }

  public render() {
    return null;
  }

}

export const ClientInfoDispatcher = connect((state: GlobalPrivateState) => ({
  clientInfo: state.clientInfo,
  configuration: state.configuration,
}))(ClientInfo);

export default ClientInfoDispatcher;

